export class UserIdentifier {
    constructor(
      public user_identifier?: string,
      public user_identifier_type?:string,
      public user_identifier_sub_type?: string
    ) { }
  }
  


// WEBPACK FOOTER //
// ./src/app/modules/send-test-profile/userIdentifier.model.ts